export const SET_FEATURE_FLAGS = 'SET_FEATURE_FLAGS';
